var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.295,
    y1: -0.359,
    x2: 1.373,
    y2: 1.554,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab5fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405cfb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(-1834 -36)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(1834 36)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1845 47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-dropdown-circle",
    "data-name": "Icon ionic-ios-arrow-dropdown-circle",
    d: "M3.375,14.723A11.348,11.348,0,1,0,14.723,3.375,11.346,11.346,0,0,0,3.375,14.723Zm15.772-2.368a1.057,1.057,0,0,1,1.489,0,1.04,1.04,0,0,1,.306.742,1.058,1.058,0,0,1-.311.747l-5.145,5.128a1.052,1.052,0,0,1-1.451-.033l-5.221-5.2A1.053,1.053,0,0,1,10.3,12.246l4.424,4.468Z",
    transform: "translate(1838.277 40.278)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.77e6a9a99cd826fdd7457182849ffb7e.svg";
export { ForwardRef as ReactComponent };